import { Container } from "@material-ui/core";

import { Grid } from "../../components/Grid";
import { Heading } from "../../components/Heading";
import { Sidebar } from "../../components/Navigation/Sidebar";
import { FormType } from "../../components/enums";
import { usePreventRefresh, useScrollDocument } from "../../hooks";

import styles from "./GenericSummary.module.scss";

type SummaryProps = {
  readonly children: Array<JSX.Element>;
  readonly currentRoute: string;
  readonly formType: FormType;
};

export const GenericSummary = ({
  children,
  currentRoute,
  formType,
}: SummaryProps): JSX.Element => {
  useScrollDocument();
  usePreventRefresh();

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Formularz zgłoszenia szkody
      </Heading>
      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar currentRoute={currentRoute} type={formType} />
        <Grid item xs={12} md={8}>
          <Heading
            color="secondary"
            component="h1"
            variant="h2"
            spacingBottom={{ xs: 4, sm: 6 }}
          >
            Podsumowanie zgłoszenia szkody
          </Heading>
          {children}
        </Grid>
      </Grid>
    </Container>
  );
};
